import script from "./NeedaaHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./NeedaaHeader.vue?vue&type=script&setup=true&lang=js"

import "./NeedaaHeader.vue?vue&type=style&index=0&id=36e5a55f&scoped=true&lang=css"

import exportComponent from "/Users/mohammad/Projects/Front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36e5a55f"]])

export default __exports__